export default {
    topic: null,
    items: [],
    item: null,
    clickedReferences: [],
    itemContent: null,
    clinicalHandouts: {},
    conversations: [],
    conversation: null,
    conversationsNextCursor: null,
}